<template>
  <div class="result pt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="mb-3">
            <h4 class="rtl text-right font-22">نتیجه تراکنش</h4>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-light table-striped text-center">
            <thead class="text-center">
              <tr class="text-center middel">
                <th>دوره های خریداری شده</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in  results.courses" :key="index">
                <td>
                  <router-link
                    class="d-block"
                    :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ item.course_id + '/' + item.course_title_en"
                  >{{item.course_title}}</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12">
          <table class="table table-light table-striped text-center">
            <thead class="text-center">
              <tr class="text-center middel">
                <!-- <th>
                                    نام دوره
                </th>-->
                <th>هزینه</th>
                <th>شماره سفارش</th>
                <th>شماره تراکنش</th>
                <th>نتیجه تراکنش</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <!-- <td v-for="(item,index) in  results.courses" :key="index">
                                    <router-link class="d-block" :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ item.course_id + '/' + item.course_title_en">
                                        {{item.course_title}}
                                    </router-link>
                </td>-->
                <td>{{results.amount}}</td>
                <td>{{results.order_id}}</td>
                <td>{{results.transaction_number}}</td>
                <td>{{results.callbackCode == 0? 'پرداخت با موفقیت انجام شد' : 'پرداخت ناموفق'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      results: {},
      isLoading: false
    }
  },
  mounted() {
    this.getResult()
  },
  methods: {
    async getResult() {
      try {
        let { data } = await axios.post('/bill/get-reuslt', { prebill: this.$route.params.id })
        if (data.state != 200) return
        // console.log(data)
        this.results = data.result[0]
        localStorage.removeItem('singleShoppingCard')
        localStorage.removeItem('shoppingCard')
        this.$store.commit("basket/SET_DATA", { data: 0, id: "lenghtBasketCard" });

      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/result-payment/_id.vue